import React from "react";
import IconButtonHT from "../../../components/IconButtonHT";
import EditNameDialog from "./EditNameDialog";
import CustomerCarePerson from "./CustomerCarePerson";


export default function EditCare({
  setEditCustomer,
  editCustomer,
  customer,
  setCustomer,
}) {
  return (
    <div className="flex flex-col items-end gap-3">
      <div>
        <IconButtonHT
          action={() => setEditCustomer(true)}
          icon="edit"
        />
      </div>
      <EditNameDialog
        open={editCustomer}
        setOpen={setEditCustomer}
        customer={customer}
        setCustomer={setCustomer}
      />
      <div className="bg-slate-50 p-2 px-4 rounded-full border border-slate-100">
        <CustomerCarePerson
          customer={customer}
          setCustomer={setCustomer}
        />
      </div>
    </div>
  );
}